module.exports = "../images/fishing-lodge-18.jpg?v=b1ce1f4";